import { useId } from "react";
import * as styles from "./_audio-component.style";

import { AudioPlayer } from "./molecule.player/_player";
import { AudioModel } from "@courses-pm2/api";
import { resets } from "@pm2/compat";

export type AudioComponentProps = {
  src: string;
  imageSrc?: string;

  caption: AudioModel["caption"];
  title?: string;
  transcript?: string;

  isScrambled: boolean;
};

export function AudioComponent(props: AudioComponentProps) {
  const id = useId();

  return (
    <section
      className={resets.rootCls}
      aria-details={
        props.transcript && !props.isScrambled ? `transcript-${id}` : undefined
      }
      data-scrambled={props.isScrambled}
    >
      <AudioPlayer
        src={props.src}
        imageSrc={props.imageSrc}
        caption={props.caption}
        title={props.title ?? ""}
        isScrambled={props.isScrambled}
      />

      {props.transcript && !props.isScrambled && (
        <aside className={styles.screenreaderOnly} id={`transcript-${id}`}>
          <div dangerouslySetInnerHTML={{ __html: props.transcript }} />
        </aside>
      )}
    </section>
  );
}
